// @ts-check
import { ModuleProcessMappings } from '@erpagroapp/common';
import {
  ConfigurationParameterReturnType,
  ConfigurationParameterSource,
} from '../enums';
import { defineConfig, defineDefaultProps } from '../helpers';

const defaultProps = defineDefaultProps(/** @type {const} */ ({
  loadingRules: {
    requiredModuleIds: [
      ModuleProcessMappings.Commercialisation.Id,
    ],
    requiredProcessIds: [
      ModuleProcessMappings.Commercialisation.Processes.SalesOrders.Id,
    ],
  },
}));

export function appOrders() {
  return defineConfig({
    UnidadesLogisticasEnProducion: {
      source: ConfigurationParameterSource.ERP,
      component: 'Comercializacion',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    FiltrarPedidosVentaVendedorAPP: {
      source: ConfigurationParameterSource.ERP,
      component: 'Comercializacion',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    TarifaPorDefecto: {
      source: ConfigurationParameterSource.ERP,
      component: 'Ventas',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
  });
}
